import { WebsiteBuilderDocuments } from './website-builder-documents';
import { IAnnouncement } from './announcement';
import { IWbThemeColors, IWebsiteBuilder } from '../api-response/auth/website-builder';
import { WebsiteBuilderView } from './website-builder-view';
import { AnyWbPageItem, WebsiteBuilderFactory } from './website-builder-factory';
import { IPublicAmenity } from '../api-response/amenity/public-amenity';
import { WebsitePage } from './website-page';
import { defaultWbThemeColors } from '../../views/website-builder/classes/theme';
import { environment } from '../../../environments/environment';
import * as _ from 'lodash';

export class WebsiteBuilder {
    public currentNavLinkMenu = 'home';
    public webView: WebsiteBuilderView = WebsiteBuilderView.index;
    public id: number = null;
    public publicDocuments: WebsiteBuilderDocuments[] = [];
    public publicAmenities: Array<IPublicAmenity> = [];
    public websitePages: { [K in WebsitePage]?: AnyWbPageItem } = {};
    public websiteName: string = '';
    public websiteTitle: string = '';
    public themeColors: IWbThemeColors = _.clone(defaultWbThemeColors);
    public websiteLogo: string = '';
    public published: boolean = false;
    public announcements: IAnnouncement[] = [];
    public selectedNoticeId: string;
    public pageKeys;

    public setCurrentMenu(navLink) {
        this.currentNavLinkMenu = navLink;
    }

    get websiteParts(): AnyWbPageItem[] {
        return this.pageKeys.map(pageKey => this.websitePages[pageKey]);
    }

    /**
     * Website Builder constructor
     *
     * @param website
     * @param showAnnouncements
     */
    constructor(website: IWebsiteBuilder = null, showAnnouncements = true) {
        WebsiteBuilderFactory.setPages(this, showAnnouncements);

        if(website) {
            this.value = website;
        }
    }

    set value(website: Partial<IWebsiteBuilder>) {
        WebsiteBuilderFactory.patch(this, website);
    }

    get value(): Partial<IWebsiteBuilder> {
        const result = {
            themeColors: this.themeColors,
            status: this.published,
            uploadLogo: this.websiteLogo,
            websiteUrl: this.websiteName ? this.websiteName + '.' + environment.domainName : '',
            websiteTitle: this.websiteTitle,
        };

        this.pageKeys.forEach(pageKey => result[pageKey] = this.websitePages[pageKey].value);

        return result;
    }
}



// WEBPACK FOOTER //
// /app/src/app/types/website-builder/website-builder.ts